"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    onDropFiles = _ref.onDropFiles;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var counterRef = (0, _react.useRef)(0);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dragOver = _useState2[0],
    setDragOver = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'relative'),
    ref: ref,
    onDragEnter: function onDragEnter() {
      counterRef.current++;
      setDragOver(true);
    },
    onDragOver: function onDragOver(e) {
      return e.preventDefault();
    },
    onDragLeave: function onDragLeave() {
      counterRef.current--;
      if (counterRef.current === 0) {
        setDragOver(false);
      }
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      setDragOver(false);
      var files = e.dataTransfer.items ? (0, _toConsumableArray2["default"])(e.dataTransfer.items).filter(function (item) {
        return item.kind === 'file';
      }).map(function (item) {
        return item.getAsFile();
      }) : (0, _toConsumableArray2["default"])(e.dataTransfer.files);
      onDropFiles(files);
    }
  }, children, dragOver && /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10 absolute inset-0 bg-secondary flex items-center justify-center border-dashed border-2 border-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('drop-files.png'),
    alt: "drop files",
    width: 70,
    height: 70
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary text-sm"
  }, t("compose.dropFile")))));
});
//# sourceMappingURL=DragableContainer.js.map